import styled from "styled-components";
import { AssetImageUrl } from "assets/imgUrls";
import { LITB_COLOR, LITB_NAV_COLOR } from "../../styles";

// -------------------------- Nav 公共组件 --------------------------
/** Nav 下拉箭头 */
export const NavArrow = styled.span`
	display: inline-block;
	width: 0;
	height: 0;
	border-right: 4px solid transparent;
	border-left: 4px solid transparent;
	content: "";
	border-top: 4px solid #999;
	vertical-align: 2px;
	margin-left: 3px;

	&.isShow {
		border-top: 4px solid ${LITB_COLOR};
		transform: rotate(180deg);
	}
`;

/** 模块分隔符 */
export const NavSplit = styled.span`
	position: relative;
	top: 1px;
	display: inline-block;
	width: 1px;
	height: 11px;
	background-color: #ccc;
	line-height: 11px;
	margin: 0 15px;
`;

/** 间隔斜线 */
export const NavSlash = styled(NavSplit)`
	margin-left: 0px;
	background: transparent;
	margin-right: 8px;
`;

/** Nav 子模块容器模板 */
export const NavModule = styled.div`
	text-align: left;
	position: relative;
	display: inline-block;
	font-size: 12px;
	font-weight: normal;
	color: #333333;
	line-height: 30px;

	&:hover ${NavArrow} {
		border-top: 4px solid ${LITB_COLOR};
		transform: rotate(180deg);
	}
`;

/** Nav 链接模版 */
export const NavLink = styled.a`
	cursor: pointer;
	text-decoration: none;
	color: #333;

	&:hover {
		color: ${LITB_COLOR};
		text-decoration: none;
	}
`;

/** Nav 国家/地区旗帜 */
export const NavRegionFlag = styled.em`
	width: 16px;
	height: 13px;
	margin: 2px 3px 0px 5.5px;
	vertical-align: -2px;
	background: url(${AssetImageUrl["pc_flag"]}) no-repeat;
	display: inline-block;
	background-position-x: -999px;
	background-position-y: -999px;
`;

// -------------------------- Nav --------------------------
/** Nav 容器 */
export const Nav = styled.div`
	position: relative;
	height: 30px;
	background-color: ${LITB_NAV_COLOR};
	text-align: right;
	z-index: 201;

	&::after,
	&::before {
		display: block;
		content: "";
		width: 100%;
		height: 30px;
		background-color: ${LITB_NAV_COLOR};
		position: absolute;
		top: 0;
	}

	&::before {
		left: -100%;
	}

	&::after {
		right: -100%;
	}
`;

// -------------------------- Nav App --------------------------
/** App 下拉框 */
export const NavAppModal = styled.div`
	display: none;
	/* left: -35.242px; */
	left: -64px;
	top: 30px;
	position: absolute;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
	border: 0;
	background: #fff;
	width: 210px;
	padding: 5px;
`;

/** App */
export const NavApp = styled(NavModule)`
	margin-right: 4px;
	&:hover ${NavAppModal} {
		display: block;
	}
`;

/** App 下拉框图标容器 */
export const NavAppModalIcons = styled.div`
	border-bottom: 0;
	overflow: hidden;
	margin-top: 10px;
	padding: 0 10px;
`;

/** 二维码 */
export const NavQRCode = styled.em`
	z-index: 5;
	position: relative;
	float: left;
	margin: 0 8px 10px 0;
	width: 140px;
	height: 140px;
	background: url(${AssetImageUrl["pc_app"]}) -155px -5px no-repeat;
`;

/** iOS */
export const NavIOS = styled.em`
	display: inline-block;
	vertical-align: top;
	margin-top: 1px;
	width: 30px;
	height: 30px;
	background: url(${AssetImageUrl["pc_app"]}) -361px -125px no-repeat;
	opacity: 1;
	padding-right: 0;
`;

/** Android */
export const NavAndroid = styled(NavIOS)`
	background: url(${AssetImageUrl["pc_app"]}) -361px -165px no-repeat;
`;

/** App 下载商店链接 */
export const NavAppLink = styled(NavLink)`
	display: block;
	padding-top: 0;
	padding-bottom: 11px;

	&:hover ${NavIOS} {
		opacity: 0.8;
	}
`;

// -------------------------- Nav Ship to --------------------------
/** Ship to 容器 */
export const NavShipToModule = styled.div`
	text-align: left;
	position: relative;
	display: inline-block;
	font-size: 12px;
	font-weight: normal;
	color: #333333;
	line-height: 30px;
`;

/** Ship to 文案 */
export const NavShipTo = styled.strong`
	font-weight: normal;
`;

/** Ship to 下拉框 */
export const NavShipToModal = styled.div`
	width: 390px;
	box-sizing: border-box;
	background: #fff;
	border: 1px solid #dedede;
	padding: 15px;
	position: absolute;
	top: 30px;
	z-index: 10;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
	border-radius: 4px;
	right: -75.375px;
`;

/** Ship to 下拉框标题 */
export const NavShipToModalTitle = styled.h4`
	font-size: 14px;
	font-weight: normal;
	margin: 0 0 5px 0;
	padding: 0;
	text-align: left;
	line-height: 20px;
`;

/** Ship to 下拉框选项栏 */
export const NavShipToSelection = styled.div`
	margin-bottom: 15px;
	position: relative;
`;

/** Ship to 下拉框结果展示框 */
export const NavShipToSelectionToggle = styled.a`
	display: inline-block;
	text-align: left;
	width: 336px;
	height: 38px;
	line-height: 38px;
	border: 1px solid #e6e6e6;
	padding: 0 10px;
	font-size: 14px;
	font-weight: normal;
	background: #fff;
	font: bold 16px/25px Helvetica;
	color: #333;
	text-decoration: none;
	vertical-align: middle;
	cursor: pointer;
`;

/** Ship to 下拉框结果展示文字 */
export const NavShipToSelectionToggleText = styled.span`
	font: bold 16px/25px Helvetica;
	color: #333;
	cursor: pointer;
	font-size: 14px;
	font-weight: normal;
	text-align: left;
	width: 336px;
	line-height: 38px;
`;

/** 国家/地区下拉框箭头 */
export const NavShipToArrow = styled(NavArrow)`
	float: right;
	margin: 15px 0 5px 5px;

	&.open {
		transform: rotate(180deg);
	}
`;

/** 国家/地区下拉框 */
export const NavRegionModal = styled.div`
	border-width: 1px;
	border-style: solid;
	position: absolute;
	top: 100%;
	z-index: 1000;
	float: left;
	min-width: 160px;
	padding: 5px 0px;
	list-style: none;
	background-color: rgb(255, 255, 255);
	left: 0;
	border-color: rgb(230, 230, 230);
	right: 0px;
	border-top-width: 0px;
`;

/** 搜索过滤框 */
export const NavRegionFilter = styled.div`
	position: relative;
`;

/** 搜索图标 */
export const NavRegionSearchIcon = styled.img`
	position: absolute;
	left: 8px;
	top: 6px;
	width: 20px;
`;

/** 搜索输入框 */
export const NavRegionMenuInput = styled.input.attrs({
	placeholderTextColor: "#999999",
})`
	border: 0;
	width: 286px;
	border-bottom: 1px solid #e6e6e6;
	line-height: 36px;
	height: 36px;
	padding: 0 35px;
	margin: 0;
	border-radius: 4px;
	vertical-align: middle;
	color: #555;
	font-size: 14px;
	display: inline-block;
	background-color: #fff;

	&:focus {
		outline: none;
	}
`;

/**  全部国家/地区列表 */
export const NavRegionCountriesList = styled.ul`
	overflow-y: scroll;
	margin: 6px 0 0 0;
	position: relative;
	height: 320px !important;
`;

/** 单个国家/地区展示 */
export const NavRegionCountryItem = styled.li`
	line-height: 32px !important;
	height: 32px !important;
	padding: 3px 37px !important;
	font-size: 14px;
	text-align: left;
	position: relative;
	white-space: normal;
	display: block;
	clear: both;
	font-weight: normal;
	color: #333;
	text-decoration: none;
	cursor: pointer;

	&:hover {
		background: #f0f0f0;
	}
`;

/** 最近选择过的国家/地区与全部的分割线 */
export const NavRegionCountriesDivider = styled.li`
	height: 2px;
	margin: 9px 1px;
	overflow: hidden;
	background-color: #e5e5e5;
	border-bottom: 1px solid #fff;
`;

/** 无搜索结果 */
export const NavRegionSearchNoResult = styled.div`
	white-space: normal;
	padding: 6px 11px;
	position: absolute;
	overflow: hidden;
	word-break: break-word;
	text-align: left;
	line-height: 2em;
	width: auto;
`;

export const NavRegionInsideFlag = styled(NavRegionFlag)`
	position: absolute;
	left: 6px;
	top: 8px;
`;

/** 货币符号 */
export const NavCurrencySymbol = styled.span`
	display: inline-block;
	margin-right: 6px;
	font-size: 14px;
	text-align: left;
	font-weight: normal;
`;

/**  全部货币列表 */
export const NavCurrencyModal = styled.ul`
	margin-top: 0;
	background-color: #fff;
	overflow-y: scroll;
	max-height: 320px;
	display: block;
	text-align: left;
	font-size: 14px;
	border-right: 1px solid #e6e6e6;
	border-left: 1px solid #e6e6e6;
	border-bottom: 1px solid #e6e6e6;
	position: absolute;
	z-index: 1000;
`;

/** 单个货币 */
export const NavCurrencyItem = styled.li`
	float: left;
	width: 33%;
	border-right: 1px solid #e6e6e6;
	cursor: pointer;

	&:nth-child(3n + 3) {
		border-right: 0;
	}
`;

/** 单个货币容器 */
export const NavCurrency = styled.a`
	line-height: 38px !important;
	height: 38px !important;
	padding: 0 15px;
	display: block;

	&:hover {
		background: #f0f0f0;
	}
`;

/** 单个货币符号 */
export const NavCurrencyModalSymbol = styled.span`
	display: inline-block;
	margin-right: 20px;
`;

/** Ship to 下拉框保存 */
export const NavShipToSaveButton = styled.div`
	width: 360px;
	background: ${LITB_COLOR};
	line-height: 36px;
	height: 36px;
	text-align: center;
	font-size: 14px;
	color: #fff;
	cursor: pointer;
`;

// -------------------------- Nav Language --------------------------
/** Language 下拉框 */
export const NavLanguageModal = styled.div`
	display: none;
	border: 1px solid #dedede;
	border-radius: 4px;
	background: #fff;
	box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
	position: absolute;
	top: 30px !important;
	padding: 0 !important;
	right: 0;
`;

/** Language */
export const NavLanguage = styled(NavModule)`
	cursor: default;
	&:hover ${NavLanguageModal} {
		display: block;
	}
`;

/** Language 列表 */
export const NavLanguageList = styled.ul`
	background: #fff;
	color: #333;
	z-index: 10;
	text-align: left;
	border-radius: 4px;
	padding: 10px 0 10px 0;
	width: 100px;
	/* height: 250px;
	overflow: scroll; */
`;

/** Language 单项 */
export const NavLanguageItem = styled.li`
	margin: 0 !important;
	display: block !important;
`;

/** Language 单项链接 */
export const NavLanguageItemLink = styled.a`
	display: block !important;
	line-height: 24px;
	padding: 0 15px !important;
	text-decoration: none;
	cursor: pointer;

	&:hover {
		background: #f0f0f0 !important;
		text-decoration: none;
		color: #333;
	}
`;
